import Button from '@mui/material/Button';
import { useState } from 'react';
import MultiFactorAuthenticationForm from '@Components/Forms/MultiFactorAuthentication/MultiFactorAuthenticationForm';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import translator from '@Components/Utilities/Translator';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';

const MultiFactorContent = (props) => {

    const [selectedTextMessage, setSelectedTextMessage] = useState(false);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const routes = useRecoilValue(atoms.routes);

    const PhoneVerificationInstrucitons = () => {
        if (currentSite?.Site?.IsAuctionTime) {
            return <p className="instructions">
                <ul>
                    <li><span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.timedauctionsphoneverificationitem1') }} /></li>
                    <li><span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.timedauctionsphoneverificationitem2') }} /></li>
                </ul>
            </p>;
        }
        else if (currentSite?.Site?.IsBidcaller) {
            return <p className="instructions">
                <ul>
                    <li><span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.liveauctionsphoneverificationitem1') }} /></li>
                    <li><span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.liveauctionsphoneverificationitem2') }} /></li>
                    <li><span dangerouslySetInnerHTML={{ __html: translator.translate('sandhills.liveauctionsphoneverificationitem3', [routes.ContactUs]) }} /></li>
                </ul>
            </p>;
        }
        else {
            return <p>{translator.translate('sandhills.phonenumberverificationinstructions')}</p>;
        }
    }

    if (selectedTextMessage) {
        return (
            <div className={currentSite?.Site?.IsAuctionSite && props.NewRegistration ? 'registration__container' : ''}>
                <h2>{translator.translate('sandhills.phonenumberverification')}</h2>
                <MultiFactorAuthenticationForm
                    {...props}
                    onMultiFactorCanceled={() => setSelectedTextMessage(false)} />
            </div>
        );
    }
    else {
        return (
            <div className={currentSite?.Site?.IsAuctionSite && props.NewRegistration ? 'registration__container' : ''}>
                <h2>{translator.translate('sandhills.phonenumberverification')}</h2>

                <div className="multifactor-registration-options-container">
                    {PhoneVerificationInstrucitons()}
                    <Button variant="contained" onClick={() => setSelectedTextMessage(true)} disabled={props.textLoading || props.textVerificationDisabled || props.flaggedAsFrequentNewBidder === true}>
                        <strong>{translator.translate('sandhills.instantverification')}</strong>
                        {props.textLoading ?
                            <LoadingRing sxBox={{ 'justify-content': 'center' }} />
                            :
                            <i className="fas fa-mobile-alt"></i>}
                        {translator.translate('sandhills.verifybytextmessage')}
                    </Button>
                    {props.textVerificationDisabled &&
                        <span className="bold red-text">{translator.translate('sandhills.nomobilenumberonregistration')}</span>}
                    <Button variant="contained" onClick={() => props.onMultiFactorAuthorized(0)}>
                        <i className="fas fa-phone-alt fa-flip-horizontal"></i>
                        {translator.translate('sandhills.verifybyphonecall')}
                    </Button>
                </div>
            </div>
        );
    }
}

export default MultiFactorContent;